import { useCallback } from 'react';

import { useGlobalAppState } from '@order/GlobalAppState';
import { useFeatureFlag } from '@order/LaunchDarkly';

export const useOnPostOrder = () => {
  const { postPurchaseModalMachineRef } = useGlobalAppState();

  // ─── Flags ───────────────────────────────────────────────────────────

  const isLoyaltyV2Enabled = useFeatureFlag('CELS-2685-loyalty-v2-enabled');

  // ─── Helpers ─────────────────────────────────────────────────────────

  const showPostPurchaseModal = useCallback(
    (_context: unknown, event: OrderSubmissionEvent) => {
      if (!isLoyaltyV2Enabled) return;

      const { order } = event.data;
      const { id: orderId, hasEarnedLoyaltyPoints } = order;

      if (!orderId || !hasEarnedLoyaltyPoints) return;

      postPurchaseModalMachineRef.send({ type: 'show', orderId });
    },
    [isLoyaltyV2Enabled, postPurchaseModalMachineRef],
  );

  // ─────────────────────────────────────────────────────────────────────

  return { onPostOrder: showPostPurchaseModal };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderSubmissionEvent = {
  data: {
    order: {
      id: string;
      hasEarnedLoyaltyPoints: boolean;
    };
  };
};
